import React, { useEffect, useState } from "react";

const MESSAGES = [
  "Ich verbinde mich mit der Seele deines Tieres…",
  "Ich lese die Aura und ihre Farben…",
  "Ich spüre die Chakren und ihre Energie…",
  "Ich erkenne Blockaden und ihre Ursachen…",
  "Ich lege die Lenormandkarten für dich…",
  "Ich male das Aura-Bild deines Tieres…",
  "Ich empfange die liebevolle Seelenbotschaft…",
];

export const LoadingScreen = ({ name }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 3500);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="loading-screen"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="relative w-56 mb-10">
        <div className="tree-aura" />
        <img src="/soul_tree.png" alt="Seelenbaum" className="tree-img relative w-full" />
      </div>

      <h2 className="font-script text-5xl sm:text-6xl text-gold mb-5">
        {name ? `${name}s Seele wird gelesen` : "Die Deutung entsteht"}
      </h2>
      <span className="divider-gold w-40 mb-6" />
      <p key={idx} className="fade-up font-play italic text-xl text-slate-600 max-w-md min-h-[56px]">
        {MESSAGES[idx]}
      </p>
      <p className="mt-8 text-sm text-slate-400">
        Bitte habe einen Moment Geduld – dies kann bis zu einer Minute dauern.
      </p>
    </div>
  );
};
